import { Component } from '@theme/component';
import { oncePerEditorSession } from '@theme/utilities';

export class ComparisonSliderComponent extends Component {
  requiredRefs = ['mediaWrapper', 'slider', 'afterImage'];

  constructor() {
    super();
    this.hasAnimated = false;
    this.boundHandleIntersection = this.handleIntersection.bind(this);
    this.boundSync = this.sync.bind(this); // ← ADDED
  }

  connectedCallback() {
    super.connectedCallback();

    const { mediaWrapper, slider } = this.refs;

    this.orientation = mediaWrapper.dataset.orientation || 'horizontal';

    this.sync();

    slider.addEventListener('input', this.boundSync); // ← ADDED

    this.setupIntersectionObserver();
  }

  sync() {
    const { mediaWrapper, slider } = this.refs;
    if (this.isAnimating) return;

    const val = (Number(slider.value) - Number(slider.min)) / (Number(slider.max) - Number(slider.min));
    const compareValue = Math.round(val * 100);

    mediaWrapper.style.setProperty('--compare', String(compareValue));
  }

  disconnectedCallback() {
    const { slider } = this.refs; // ← ADDED
    if (slider) {                  // ← ADDED
      slider.removeEventListener('input', this.boundSync); // ← ADDED
    }                              // ← ADDED

    if (this.intersectionObserver) {
      this.intersectionObserver.disconnect();
    }
  }

  setValue(value) {
    const { slider } = this.refs;
    if (!slider) return;

    slider.value = String(value);
    this.sync();
  }

  animateSlider() {
    const { mediaWrapper, slider } = this.refs;
    if (this.hasAnimated) return;

    this.hasAnimated = true;
    this.isAnimating = true;

    mediaWrapper.style.setProperty('--transition-duration', '0.5s');

    setTimeout(() => { mediaWrapper.style.setProperty('--compare', '40'); }, 100);
    setTimeout(() => { mediaWrapper.style.setProperty('--compare', '60'); }, 600);
    setTimeout(() => { mediaWrapper.style.setProperty('--compare', '50'); }, 1100);

    setTimeout(() => {
      mediaWrapper.style.setProperty('--transition-duration', '0s');
      slider.value = '50';
      this.isAnimating = false;
    }, 1600);
  }

  setupIntersectionObserver() {
    if (!window.IntersectionObserver) return;

    this.intersectionObserver = new IntersectionObserver(this.boundHandleIntersection, {
      root: null,
      rootMargin: '0px',
      threshold: 0.5,
    });
    this.intersectionObserver.observe(this);
  }

  handleIntersection(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting && !this.hasAnimated) {
        setTimeout(() => {
          oncePerEditorSession(this, `comparison-slider-animated`, () => {
            this.animateSlider();
          });
        }, 300);

        if (this.intersectionObserver) {
          this.intersectionObserver.disconnect();
        }
      }
    });
  }
}

if (!customElements.get('comparison-slider-component')) {
  customElements.define('comparison-slider-component', ComparisonSliderComponent);
}
